module.exports = __webpack_public_path__ + "img/device_bg.dafeb3d1.png";